import * as imagesLoaded from "imagesloaded";

export default class Masonry {

    resizeAllGridItems() {
        const allItems = [].slice.call(document.querySelectorAll('.article-list-item'));
        for (var item of allItems) {
            const grid = document.getElementsByClassName("article-list")[0] as HTMLElement;
            const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
            const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
            const content = item.querySelector(".content") as HTMLElement;
            const rowSpan = Math.ceil((content.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
            item.setAttribute("style", "grid-row-end: span " + rowSpan);
        }
    }

    waitForImages() {
        const allItems = [].slice.call(document.querySelectorAll('.article-list-item'));
        for (var item of allItems) {
            imagesLoaded(item, function (instance) {
                var item1 = instance.elements[0];
                const grid = document.getElementsByClassName("article-list")[0] as HTMLElement;
                const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
                const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
                const content = item1.querySelector(".content") as HTMLElement;
                const rowSpan = Math.ceil((content.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
                item1.setAttribute("style", "grid-row-end: span " + rowSpan);
            });
        }
    }
}